// sharing a link: the phone's share sheet where there is one, otherwise the link copied
// ('copied' so the caller can say so; null when the player closed the share sheet or nothing worked)
export async function shareLink(link: { title: string; url: string; text?: string }) {
  try {
    if (navigator.share) {
      await navigator.share(link);
      return 'shared' as const;
    }
    await navigator.clipboard.writeText(link.text ? `${link.text} ${link.url}` : link.url);
    return 'copied' as const;
  } catch {
    // closing the share sheet is fine
    return null;
  }
}
